<template lang="pug">
.links
	h1 Полезные ссылки
	.links__cat(v-for="(cat, name) in links")
		h2 {{name}}
		.links__item(v-for="link in cat")
			a.links__link(:href="link.linkUrl") {{link.linkName}}
			.links__desc
				vue-markdown {{link.linkDesc}}

</template>
<script>
import { mapGetters } from "vuex";
import VueMarkdown from "vue-markdown";

export default {
	name: "links",
	computed: {
		...mapGetters({
			links: "main/linksItems",
			loading: "main/loading",
			loaded: "main/loaded"
		})
	},
	data() {
		return {};
	},
	methods: {},
	components: {
		VueMarkdown
	}
};
</script>
<style lang="stylus">
.links
	max-width 1000px
	margin 0 auto
	padding 30px 20px

	h2
		margin-bottom 5px
		margin-top 0
		padding-top 0
		font-family Oswald
		text-transform uppercase
		color #aaa
		font-weight 400

	&__item
		padding-bottom 10px

	&__cat
		padding-bottom 10px

	&__link, &__link:visited
		color #610a84
</style>